module.exports = __webpack_public_path__ + "media/images/country_flags/jp-d88d81ef78895e2902b542ed80f3c069.png";